import React, {Fragment, useRef, useState} from 'react';
import Button from "../UI/Button";
import Modal from "../UI/Modal";
import ListEdit from "../UI/ListEdit";
import ModalForm from "../UI/ModalForm";
import ModalFormInputRow from "../UI/ModalFormInputRow";
import {createExam, getExam, updateExam} from "../../api/examApiClient";
import {useExams} from "../../hooks/useExams";
import {useNavigate} from 'react-router-dom';
import Box from "../UI/Box";
import {toast} from "react-toastify";

const ExamList = (props) => {
    const [showModal, setShowModal] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [exam, setExam] = useState([]);
    const [submitCount, setSubmitCount] = useState(0);
    const nameRef = useRef(null);
    const {exams, pagination} = useExams(page, pageSize, submitCount);
    const navigate = useNavigate();

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
    };

    const handlePageSizeChange = (pageSize) => {
        setPageSize(pageSize);
        setPage(1);
    };

    const handleEditIconClick = (examId) => {
        setIsUpdate(true);
        // @todo Implement abort
        const exam = getExam(examId);

        exam
            .then(
                (data) => {
                    setExam(data)
                    setShowModal(true)
                }
            )
            .catch(
                (error) => console.log(error)
            );
    }

    const handleShowIconClick = (examId) => {
        navigate('/exams/' + examId + '/requirements');
    }

    const handleCreateButtonClick = (examId) => {
        setIsUpdate(false);
        setShowModal(true)
    }

    const handleCreateSubmit = (event) => {
        event.preventDefault();
        const name = nameRef.current.value;

        createExam(name)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const handleEditSubmit = (event) => {
        event.preventDefault();
        const name = nameRef.current.value;

        updateExam(exam.id, name)
            .then(() => {
                setShowModal(false)
                setSubmitCount(prevCount => prevCount + 1);
                toast.success('Success!');
            })
            .catch(
                (error) => {
                    toast.error(error.message);
                }
            );
    }

    const listHeaders = [
        'Id',
        'Name',
        'Actions'
    ];

    const columns = {
        functionParams : ['id'],
        dataKeys       : [
            'id',
            'name'
        ],
    }

    return <Fragment>
        <Box>
            <Button title='Create exam' handleClick={handleCreateButtonClick}/>
            <ListEdit
                headers={listHeaders}
                items={exams}
                columns={columns}
                pagination={pagination}
                handleEditIconClick={handleEditIconClick}
                handleShowIconClick={handleShowIconClick}
                handlePageChange={handlePageChange}
                handlePageSizeChange={handlePageSizeChange}
            />
        </Box>
        {showModal && (
            <Modal>
                <form onSubmit={isUpdate ? handleEditSubmit : handleCreateSubmit}>
                    <ModalForm
                        title={isUpdate ? 'Update exam' : 'Create exam' +
                            ''}
                        saveButtonTitle={isUpdate ? 'Update' : 'Create'}
                        handleCancelButtonClick={() => setShowModal(false)}
                    >
                        <ModalFormInputRow title='Name'>
                            <input
                                ref={nameRef}
                                type="text"
                                id="name"
                                name="name"
                                defaultValue={isUpdate ? exam.name : null}
                                placeholder="Enter name"
                                className="border rounded-lg py-2 px-3 w-full text-gray-700 focus:outline-none focus:shadow-outline"
                            />
                        </ModalFormInputRow>
                    </ModalForm>
                </form>
            </Modal>
        )}
    </Fragment>;
}

export default ExamList;